import { Card } from 'antd';
import { AppBox } from './boxes/AppBox';

export function AppCard({ as, ...rest }) {
  return <AppBox {...rest} as={Card} />;
}
